var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isMobile === false)?_c('PCContactUs',{attrs:{"infor":_vm.infor}}):(_vm.isMobile === true)?_c('MobContactUs',{attrs:{"infor":_vm.infor}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }